import React, { useState } from "react";
import IllustrateStyle from "./Illustrate.module.css";
import { Typography, Layout, Menu, Table } from "antd";
const { Title } = Typography;
const { Sider, Content } = Layout;

function Illustrate() {
  const [selectedKey, setSelectedKey] = useState("8");
  const [subMenuKey, setSubMenuKey] = useState("8");
  const [openKeys, setOpenKeys] = useState([]);

  // 处理一级菜单点击
  const handleMenuClick = (key) => {
    setSelectedKey(key);
    setSubMenuKey("1"); // 重置二级菜单，默认显示第一个内容
    if (key === "1" || key === "5" || key === "8") {
      setOpenKeys([]); // 取消展开其他菜单
    }
  };

  // 处理二级菜单点击
  const handleSubMenuClick = (key) => {
    setSubMenuKey(key); // 更新二级菜单选中项
  };

  // 处理菜单展开项变化
  const handleOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey) {
      setOpenKeys([latestOpenKey]);
    } else {
      setOpenKeys([]);
    }
  };

  return (
    <div className={IllustrateStyle.Illustrate_app}>
        <div className={IllustrateStyle.Help_Model_introduction_over}>
                  <Title level={4} style={{ width: "100%" ,display:"flex",alignItems:"center",justifyContent:"center"}}>
                    Overview
                  </Title>
                  <p className={IllustrateStyle.IllustrateH1}>
                    The Lotus Database collects various germplasm resources and
                    omics data of lotus, aiming to help researchers gain deeper
                    insights into the genetic information, gene expression
                    regulation mechanisms, and metabolic pathways of lotus. It
                    also facilitates genetic research on lotus, contributing to
                    its conservation and utilization.
                  </p>
                  <img
                    src={require("./img/图片1.png")}
                    style={{ width: "50%", margin: "auto" }}
                    alt=""
                  />
                </div>
      <Layout
        style={{
          width: "90%",
          height: "500px",
          margin: "20px auto",
          background: "#fff",
        }}
      >
        {/* 侧边栏 */}
        <Sider
          width={250}
          style={{
            overflowY: "auto", // 添加滚动条
            background: "#fff",
          }}
        >
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            openKeys={openKeys} // 绑定展开的菜单项
            onOpenChange={handleOpenChange} // 处理菜单展开项的变化
            style={{ background: "#fff" }}
          >
            {/* <Menu.Item
              key="1"
              onClick={() => handleMenuClick("1")}
              className={
                selectedKey === "1" ? IllustrateStyle.activeSubMenuItem : ""
              }
            >
              <span className={IllustrateStyle.HelpMenuTitle1}>Overview</span>
            </Menu.Item> */}
            <Menu.Item
              key="8"
              onClick={() => handleMenuClick("8")}
              className={
                selectedKey === "8" ? IllustrateStyle.activeSubMenuItem : ""
              }
            >
              <span className={IllustrateStyle.HelpMenuTitle1}>Resource</span>
            </Menu.Item>
            <Menu.SubMenu
              key="2"
              title={
                <span className={IllustrateStyle.HelpMenuTitle1}>Genome</span>
              }
              onTitleClick={() => handleMenuClick("2")}
              className={
                selectedKey === "2" ? IllustrateStyle.selectedSubMenu : ""
              }
            >
              <Menu.Item
                key="2-1"
                onClick={() => handleSubMenuClick("1")}
                className={
                  subMenuKey === "1" ? IllustrateStyle.activeSubMenuItem : ""
                }
              >
                <span className={IllustrateStyle.HelpMenuTitle}>
                  Assembly and Annotation
                </span>
              </Menu.Item>
              <Menu.Item
                key="2-2"
                onClick={() => handleSubMenuClick("2")}
                className={
                  subMenuKey === "2" ? IllustrateStyle.activeSubMenuItem : ""
                }
              >
                <span className={IllustrateStyle.HelpMenuTitle}>
                  Gene Index
                </span>
              </Menu.Item>
            </Menu.SubMenu>
            <Menu.SubMenu
              key="3"
              title={
                <span className={IllustrateStyle.HelpMenuTitle1}>
                  Populations
                </span>
              }
              onTitleClick={() => handleMenuClick("3")}
              className={
                selectedKey === "3" ? IllustrateStyle.selectedSubMenu : ""
              }
            >
              <Menu.Item
                key="3-1"
                onClick={() => handleSubMenuClick("1")}
                className={
                  subMenuKey === "1" ? IllustrateStyle.activeSubMenuItem : ""
                }
              >
                <span className={IllustrateStyle.HelpMenuTitle}>
                  Population Structure
                </span>
              </Menu.Item>
              <Menu.Item
                key="3-2"
                onClick={() => handleSubMenuClick("2")}
                className={
                  subMenuKey === "2" ? IllustrateStyle.activeSubMenuItem : ""
                }
              >
                <span className={IllustrateStyle.HelpMenuTitle}>
                  Mutation information query
                </span>
              </Menu.Item>
            </Menu.SubMenu>
            <Menu.SubMenu
              key="4"
              title={
                <span className={IllustrateStyle.HelpMenuTitle1}>
                  Transcriptome
                </span>
              }
              onTitleClick={() => handleMenuClick("4")}
              className={
                selectedKey === "4" ? IllustrateStyle.selectedSubMenu : ""
              }
            >
              <Menu.Item
                key="4-1"
                onClick={() => handleSubMenuClick("1")}
                className={
                  subMenuKey === "1" ? IllustrateStyle.activeSubMenuItem : ""
                }
              >
                <span className={IllustrateStyle.HelpMenuTitle}>RNA-seq</span>
              </Menu.Item>
              <Menu.Item
                key="4-2"
                onClick={() => handleSubMenuClick("2")}
                className={
                  subMenuKey === "2" ? IllustrateStyle.activeSubMenuItem : ""
                }
              >
                <span className={IllustrateStyle.HelpMenuTitle}>
                  Expression analysis
                </span>
              </Menu.Item>
            </Menu.SubMenu>
            <Menu.Item
              key="5"
              onClick={() => handleMenuClick("5")}
              className={
                selectedKey === "5" ? IllustrateStyle.activeSubMenuItem : ""
              }
            >
              <span className={IllustrateStyle.HelpMenuTitle1}>Metabolome</span>
            </Menu.Item>
            <Menu.SubMenu
              key="6"
              title={
                <span className={IllustrateStyle.HelpMenuTitle1}>
                  Epigenome
                </span>
              }
              onTitleClick={() => handleMenuClick("6")}
              className={
                selectedKey === "6" ? IllustrateStyle.selectedSubMenu : ""
              }
            >
              <Menu.Item
                key="6-1"
                onClick={() => handleSubMenuClick("1")}
                className={
                  subMenuKey === "1" ? IllustrateStyle.activeSubMenuItem : ""
                }
              >
                <span className={IllustrateStyle.HelpMenuTitle}>
                  DNA methylation Search
                </span>
              </Menu.Item>
              <Menu.Item
                key="6-2"
                onClick={() => handleSubMenuClick("2")}
                className={
                  subMenuKey === "2" ? IllustrateStyle.activeSubMenuItem : ""
                }
              >
                <span
                  className={IllustrateStyle.HelpMenuTitle}
                  style={{
                    display: "inline-block",
                    overflowWrap: "break-word",
                    wordBreak: "break-word",
                  }}
                >
                  Changes in organizational methylation levels
                </span>
              </Menu.Item>
            </Menu.SubMenu>
            <Menu.SubMenu
              key="7"
              title={
                <span className={IllustrateStyle.HelpMenuTitle1}>Tools</span>
              }
              onTitleClick={() => handleMenuClick("7")}
              className={
                selectedKey === "7" ? IllustrateStyle.selectedSubMenu : ""
              }
            >
              <Menu.Item
                key="7-1"
                onClick={() => handleSubMenuClick("1")}
                className={
                  subMenuKey === "1" ? IllustrateStyle.activeSubMenuItem : ""
                }
              >
                <span className={IllustrateStyle.HelpMenuTitle}>JBrowser</span>
              </Menu.Item>
              <Menu.Item
                key="7-2"
                onClick={() => handleSubMenuClick("2")}
                className={
                  subMenuKey === "2" ? IllustrateStyle.activeSubMenuItem : ""
                }
              >
                <span className={IllustrateStyle.HelpMenuTitle}>Blast</span>
              </Menu.Item>
              <Menu.Item
                key="7-3"
                onClick={() => handleSubMenuClick("3")}
                className={
                  subMenuKey === "3" ? IllustrateStyle.activeSubMenuItem : ""
                }
              >
                <span className={IllustrateStyle.HelpMenuTitle}>
                  GO/KEGG enrichment
                </span>
              </Menu.Item>
              <Menu.Item
                key="7-4"
                onClick={() => handleSubMenuClick("4")}
                className={
                  subMenuKey === "4" ? IllustrateStyle.activeSubMenuItem : ""
                }
              >
                <span className={IllustrateStyle.HelpMenuTitle}>
                  Primer Design
                </span>
              </Menu.Item>
              <Menu.Item
                key="7-5"
                onClick={() => handleSubMenuClick("5")}
                className={
                  subMenuKey === "5" ? IllustrateStyle.activeSubMenuItem : ""
                }
              >
                <span className={IllustrateStyle.HelpMenuTitle}>HeatMap</span>
              </Menu.Item>
              <Menu.Item
                key="7-6"
                onClick={() => handleSubMenuClick("6")}
                className={
                  subMenuKey === "6" ? IllustrateStyle.activeSubMenuItem : ""
                }
              >
                <span className={IllustrateStyle.HelpMenuTitle}>TF</span>
              </Menu.Item>
            </Menu.SubMenu>
            <Menu.Item
              key="9"
              onClick={() => handleMenuClick("9")}
              className={
                selectedKey === "9" ? IllustrateStyle.activeSubMenuItem : ""
              }
            >
              <span className={IllustrateStyle.HelpMenuTitle1}>DownLoad</span>
            </Menu.Item>
          </Menu>
        </Sider>

        <Layout style={{ overflow: "auto", background: "#fff" }}>
          <Content
            style={{
              padding: 24,
              height: "auto",
              backgroundColor: "#fff",
            }}
          >
            {/* 根据选中的菜单显示不同内容 */}
            <div style={{ width: "100%", height: "100vh", background: "#fff" }}>
              {/* {selectedKey === "1" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    Overview
                  </Title>
                  <p className={IllustrateStyle.IllustrateH1}>
                    The Lotus Database collects various germplasm resources and
                    omics data of lotus, aiming to help researchers gain deeper
                    insights into the genetic information, gene expression
                    regulation mechanisms, and metabolic pathways of lotus. It
                    also facilitates genetic research on lotus, contributing to
                    its conservation and utilization.
                  </p>
                  <img
                    src={require("./img/图片1.png")}
                    style={{ width: "70%", margin: "auto" }}
                    alt=""
                  />
                </div>
              )} */}
              {selectedKey === "8" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    Resource
                  </Title>
                  <Title level={5} style={{ width: "95%", margin: "auto" }}>
                    1.1 Germplasm information
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                    This table displays the names, codes, sources, and types of
                    different lotus varieties both domestically and
                    internationally, aiding in the analysis of lotus cultivation
                    and domestication
                  </p>
                  <p style={{ height: "20px" }}></p>
                  <Title level={5} style={{ width: "95%", margin: "auto" }}>
                    1.2 Introduction to Lotus Varieties
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                    Lotus varieties are classified based on different species,
                    regional distribution, lotus uses, and sources. Each
                    category is further subdivided according to the shape of
                    lotus petals, presented in graphical form to clearly
                    illustrate the characteristics and differences among various
                    lotus varieties. Additionally, each lotus variety is
                    accompanied by a detailed description, including information
                    on its origin, plant type, flower color, and more, providing
                    readers with comprehensive knowledge about lotus.
                  </p>
                </div>
              )}
              {/* Genome */}
              {selectedKey === "2" && subMenuKey === "1" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                  Assembly and Annotation
                  </Title>

                  <p className={IllustrateStyle.IllustrateH2}>
                    The first part of the table provides detailed assembly and
                    annotation information about different genomes, including
                    Asian Lotu, TaiZilotus, Zi-lotus, and Genome Americanlotus
                    2022.
                  </p>
                  <p className={IllustrateStyle.IllustrateH2}>
                    The second part of the table provides assembly information
                    about the genome, including statistical data on the number,
                    length, GC content, and different N values (such as N10,
                    N20, etc.) of Contigs and Scaffolds. These data are very
                    useful for evaluating the assembly quality of the genome and
                    determining whether there are large deletions or
                    duplications. You can select the genome details you want to
                    search for through the drop-down menu.
                  </p>
                  <p style={{ height: "20px" }}></p>

                  
                </div>
              )}
              {selectedKey === "2" && subMenuKey === "2" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    Gene Index
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                  By selecting the genome and searching for genes, such as entering the gene ID, indexing the target gene, and searching for detailed information about the gene.
                  </p>
                </div>
              )}
              {/* Populations */}
              {selectedKey === "3" && subMenuKey === "1" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    Population Structure
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                  Analyze the genetic differences and phylogenetic relationships among lotus varieties using methods such as PCA plots, phylogenetic trees, and population structure analysis. The population structure analysis allows for quantitative selection.
                  </p>
                </div>
              )}
              {selectedKey === "3" && subMenuKey === "2" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    Mutation information query
                  </Title>
                  <Title level={5} style={{ width: "95%" }}>
                    Mutation information query
                  </Title>
                  <p className={IllustrateStyle.IllustrateH3}>
                  Select a specific gene ID or gene region in the “Method” section, and choose the gene structural features in the “Gene body” section. Customize the analysis by selecting different options to obtain information on gene variations, mutation bases, and more.
                  </p>
                  <p style={{ height: "20px" }}></p>
                  <Title level={5} style={{ width: "95%" }}>
                    Haplotype Analysis
                  </Title>
                  <p className={IllustrateStyle.IllustrateH3}>
                  Provide the sample name sets for Group1 and Group2, and select the specified target region, such as chromosome number, start position, and end position. The system will calculate and generate haplotype analysis results based on this information. The results display allele information for specific variant sites across different chromosomes, and the genomic sequence for the target region can be downloaded.
                  </p>
                </div>
              )}
              {/* Expression */}
              {selectedKey === "4" && subMenuKey === "1" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    RNA-seq
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                  By selecting the gene expression calculation method, specific gene ID, desired tissue type, and time points, the expression levels of a specific gene in different tissues (e.g., seeds, leaves) at various time points can be analyzed. The results are presented in the form of heatmaps and tables, and are available for download.
                  </p>
                </div>
              )}
              {selectedKey === "4" && subMenuKey === "2" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    Expression analysis
                  </Title>
                  <Title level={5} style={{ width: "95%" }}>
                    Expression display
                  </Title>
                  <p className={IllustrateStyle.IllustrateH3}>
                  The complete expression levels of different tissues of lotus varieties such as Jianxuan No.17 are displayed in the form of a table, which can be searched for gene ID, sample, variety, tissue, and period as needed. The table can be downloaded.
                  </p>
                  <p style={{ height: "20px" }}></p>
                  <Title level={5} style={{ width: "95%" }}>
                    Diffrent expression analysis
                  </Title>
                  <p className={IllustrateStyle.IllustrateH3}>
                  Select comparison samples and comparison tissues, set the comparison period, analyze differentially expressed genes in lotus, display differential expression analysis results in a table format, perform clustering analysis using heatmaps and volcano plots, and conduct GO/KEGG enrichment analysis, presenting the results in bar charts and tables.
                  </p>
                </div>
              )}
              {/* Metabolome */}
              {selectedKey === "5" && subMenuKey === "1" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    Metabolome
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                  The metabolite detection results and quantitative values of lotus variety Lishui S2 were displayed, which can be used to select the displayed tissues and view the quantitative situation of metabolites in different tissues. The results can be downloaded.
                  </p>
                </div>
              )}
              {/* Epigenome */}
              {selectedKey === "6" && subMenuKey === "1" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    DNA methylation Search
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                  Display the methylation status of different samples in specific tissues and periods in the form of a table, and the results can be downloaded.
                  </p>
                  <p className={IllustrateStyle.IllustrateH2}>
                  Analyze the differential expression of methylation in different samples, tissues, and periods, and present the results in the form of a table, which can be downloaded. At the same time, display the differences using violin charts, heatmap, bar charts, etc. And perform GO/KEGG enrichment analysis, presented in the form of tables and bar charts, and the results can be downloaded.
                  </p>
                </div>
              )}
              {selectedKey === "6" && subMenuKey === "2" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    Changes in organizational methylation levels
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                  Display the changes in methylation levels in different organizations in the form of a line chart.
                  </p>
                </div>
              )}
              {/* Tools */}
              {selectedKey === "7" && subMenuKey === "1" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    JBrowser
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                  Display the changes in methylation levels in different organizations in the form of a line chart.
                  </p>
                </div>
              )}{" "}
              {selectedKey === "7" && subMenuKey === "2" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    Blast
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                  Import the text file into the input box. The file can contain either base sequences or nucleotide sequences. Select the parameters and perform the alignment.
                  </p>
                </div>
              )}
              {selectedKey === "7" && subMenuKey === "3" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    GO/KEGG enrichment
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                  Perform enrichment analysis on the target sequence by selecting the enrichment analysis type, entering the target sequence, selecting the parameters, and running the analysis.
                  </p>
                </div>
              )}
              {selectedKey === "7" && subMenuKey === "4" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    Primer Design
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                  Enter the sequence, customize the primer design conditions, and design the primers. The primer design results are presented in a table, with the first primer pair recommended for selection.
                  </p>
                </div>
              )}
              {selectedKey === "7" && subMenuKey === "5" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    HeatMap
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                  Create a project by entering a gene set or selecting a file, customize the heatmap’s length, width, and color scheme, and generate the heatmap. Gene information is displayed in table format, along with the search results and heatmap defined by the selected format.
                  </p>
                </div>
              )}
              {selectedKey === "7" && subMenuKey === "6" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    TF{" "}
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                  Predicting unknown transcription factors helps reveal the mechanisms of gene expression regulation.
                  </p>
                </div>
              )}
              {selectedKey === "9" && (
                <div className={IllustrateStyle.Help_Model_introduction}>
                  <Title level={4} style={{ width: "100%" }}>
                    Download
                  </Title>
                  <p className={IllustrateStyle.IllustrateH2}>
                  Create a download link to provide the data.
                  </p>
                </div>
              )}
            </div>
          </Content>
        </Layout>
      </Layout>
      <div style={{ height: "20px" }}></div>
    </div>
  );
}

export default Illustrate;
